import { render } from "./PaymentStatusForm.vue?vue&type=template&id=c8a542c0&scoped=true"
import script from "./PaymentStatusForm.vue?vue&type=script&lang=js"
export * from "./PaymentStatusForm.vue?vue&type=script&lang=js"

import "./PaymentStatusForm.vue?vue&type=style&index=0&id=c8a542c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8a542c0"]])

export default __exports__